// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { COST_OF_SALES_REDUCER_KEY } from "..";
import {
  contentProductionKeyMonth,
  dubbingArtistsKeyMonth,
  musicKey,
  studioKeyMonth,
  writtenContentKeyMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// other revenue keys
export const CONTENT_PRODUCTION_COST_KEY = "contentProductionKey";
export const WRITTEN_CONTENT_KEY = "writtenContentKey";
export const STUDIO_KEY = "studioKey";
export const DUBBING_ARTISTS_KEY = "dubbingArtistsKey";
export const MUSIC_KEY = "musicKey";

export const costOfSalesItems = [
  CONTENT_PRODUCTION_COST_KEY,
  WRITTEN_CONTENT_KEY,
  STUDIO_KEY,
  DUBBING_ARTISTS_KEY,
  MUSIC_KEY,
];

export const initialState = {
  [CONTENT_PRODUCTION_COST_KEY]: {
    title: "Content & Production Costs",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 1; i < costOfSalesItems.length; i++) {
        result += Number(
          getReducerFunc(COST_OF_SALES_REDUCER_KEY)[costOfSalesItems[i]][
            "years"
          ][yearKey]
        );
      }
      return result;
    },
    months: contentProductionKeyMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [WRITTEN_CONTENT_KEY]: {
    title: "Written Content",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: writtenContentKeyMonth,
    years: {
      [years.YEAR_1_KEY]: 1000,
      [years.YEAR_2_KEY]: 1250,
      [years.YEAR_3_KEY]: 1250,
      [years.YEAR_4_KEY]: 1250,
      [years.YEAR_5_KEY]: 1250,
    },
  },
  [STUDIO_KEY]: {
    title: "Studio",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: studioKeyMonth,
    years: {
      [years.YEAR_1_KEY]: 500,
      [years.YEAR_2_KEY]: 500,
      [years.YEAR_3_KEY]: 600,
      [years.YEAR_4_KEY]: 600,
      [years.YEAR_5_KEY]: 600,
    },
  },
  [DUBBING_ARTISTS_KEY]: {
    title: "Dubbing Artists",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: dubbingArtistsKeyMonth,
    years: {
      [years.YEAR_1_KEY]: 250,
      [years.YEAR_2_KEY]: 250,
      [years.YEAR_3_KEY]: 250,
      [years.YEAR_4_KEY]: 300,
      [years.YEAR_5_KEY]: 250,
    },
  },
  [MUSIC_KEY]: {
    title: "Music",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: musicKey,
    years: {
      [years.YEAR_1_KEY]: 350,
      [years.YEAR_2_KEY]: 350,
      [years.YEAR_3_KEY]: 350,
      [years.YEAR_4_KEY]: 350,
      [years.YEAR_5_KEY]: 450,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const costOfSalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COST_OF_SALE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key]?.years,
            [action.yearKey]: action.amount,
          },
        },
      };
    case actionTypes.SET_COST_OF_SALE_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key]?.months,
            [action.yearKey]: action.amount,
          },
        },
      };
    case actionTypes.REPLACE_COST_OF_SALES_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_COST_OF_SALES_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default costOfSalesReducer;
